module.exports = __webpack_public_path__ + "static/assets/5393c878bb93c3a5e7cd93808b1ef948.png";